import React, { FC, ReactNode, useState } from 'react';
import {
  captureAbandonedCartAttribution,
  resolveAbandonedCartAttribution,
} from '../../../utils/abandonedCartAttribution';

interface AbandonedCartRouteGateProps {
  search: string | undefined;
  // The route tree for a visit from an abandoned-cart reminder link.
  restoreRoute: ReactNode;
  // The route tree every other cart visit gets -- unchanged from before.
  children: ReactNode;
}

// Chooses the /v3/cart tree once per mount. A visit that carries a reminder
// target -- in the URL, or stashed across login -- gets the restore tree; every
// other visit renders `children`, the tree the route always had.
//
// The capture has to run before the auth gate inside either tree can redirect
// a logged-out click to /login-redirect, which hard-reloads and drops the query
// string for good, so it runs in the state initializer, during this render.
const AbandonedCartRouteGate: FC<AbandonedCartRouteGateProps> = ({
  search,
  restoreRoute,
  children,
}) => {
  const [restoring] = useState(() => {
    captureAbandonedCartAttribution(search);
    const target = resolveAbandonedCartAttribution(search, { consume: false });
    return Boolean(target.cartUuid || target.abandonedCartNotificationId);
  });

  return <>{restoring ? restoreRoute : children}</>;
};

export default AbandonedCartRouteGate;
